/*
  [JS Index - plugins]
*/

/*
  1. jQuery v3.7.1
  2. jquery.countTo
  3. jquery.appear
  4. jquery-css-skills-bar
  5. jquery.mb.YTPlayer v3.1.4
  6. Slick v1.6.0
  7. Fullscreeneo v1.0.0
  8. Owl Carousel v2.2.1
  9. Magnific Popup v1.1.0
  10. Lity v2.2.2
  11. fullPage v2.9.4
  12. ScrollMagic v2.0.5
  13. core v1.0.2
  14. Vide v0.5.1
  15. Swiper v4.4.0
  16. Bootstrap v3.3.7
*/

// var jquery = require("./js/jquery.js");
import jquery from 'jquery';
window.jQuery = window.$ = jquery;
globalThis.jQuery = globalThis.$ = jquery;

// 2. jquery.countTo
import './js/countTo.js';

// 3. jquery.appear
import './js/appear.js';

// 4. jquery-css-skills-bar
import './js/jquery-css-skills-bar.js';

// 5. jquery.mb.YTPlayer v3.1.4
import './js/jquery.mb.YTPlayer.js';

// 6. Slick v1.6.0
import './js/slick.js';

// 7. Fullscreeneo v1.0.0
// import './js/Fullscreeneo.js';

// 8. Owl Carousel v2.2.1
import './js/owl-carousel.js';

// 9. Magnific Popup v1.1.0
import './js/magnific-popup.js';

// 10. Lity v2.2.2
import './js/lity.js';

// 11. fullPage v2.9.4
import './js/fullPage.js';

// 12. ScrollMagic v2.0.5
import ScrollMagic from './js/scrollMagic.js';

// 13. core v1.0.2
// scrollMagic
$(function() {
    "use strict";
    var r = new ScrollMagic.Controller
      , o = $(".light-mode");
    $.each(o, function(o, e) {
        var n = $(e)
          , t = n.outerHeight()
          , l = new ScrollMagic.Scene({
            triggerElement: e,
            triggerHook: 0,
            duration: t,
            offset: -120
        }).setClassToggle(".logo").addTo(r).on("enter", function(o) {
            $(".logo").addClass("logo-light"),
            $(".round-menu").addClass("round-menu-light")
        }).on("leave", function(o) {
            $(".logo").removeClass("logo-light"),
            $(".round-menu").removeClass("round-menu-light")
        });
        $(window).on("resize", function() {
            l.duration(n.outerHeight())
        })
    }),
    o = $(".dark-mode"),
    $.each(o, function(o, e) {
        var n = $(e)
          , t = n.outerHeight()
          , l = new ScrollMagic.Scene({
            triggerElement: e,
            triggerHook: 0,
            duration: t,
            offset: -120
        }).setClassToggle(".logo").addTo(r).on("enter", function(o) {
            $(".logo").removeClass("logo-light"),
            $(".round-menu").removeClass("round-menu-light")
        }).on("leave", function(o) {
            $(".logo").addClass("logo-light"),
            $(".round-menu").addClass("round-menu-light")
        });
        $(window).on("resize", function() {
            l.duration(n.outerHeight())
        })
    })
});

// 14. Vide v0.5.1
import './js/vide.js';

// 15. Swiper v4.4.0
import './js/swiper.js';

// 16. Bootstrap v3.3.7
import './js/bootstrap.js';